import React, { useState, useEffect } from 'react';
import { Route, useLocation, useNavigate, useParams, Routes } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import DocumentsPage from '../Pages/documents/page';
import OperationsCustomer from '../Pages/Operaciones/OperationsCustomer';
import './navigation.css';
import FrequentQuestions from '../Pages/frequentQuestions';
import ContactoPage from '../Pages/ContactoPage';
import HeaderComponent from './header/headerComponent';
import NotificationsPage from '../Pages/notificationsPage';
import Login from '../Pages/auth/login';
import { dataProfile, dataSummary } from '../store/data/actions';
import { getProfile } from '../store/auth/actions';
import { getOperations } from '../store/realestate/actions';
import Home from '../Pages/Home';
import HeaderComponentMovile from './header/headerComponentMovil';
import queryString from 'query-string';
import TagManager from './tagmanager';
import env from '../environment';
import axios from 'axios';
import jwt_decode from 'jwt-decode';
import { BrowserView, MobileView, TabletView, isTablet, isMobileOnly } from 'react-device-detect';

import LoaderLogo from './LoaderLogo';
import { useTranslation } from 'react-i18next';
import googlePlay from '../assets/init/googlePlay.png';
import appleStore from '../assets/init/appleStore.png';
import { Layout, Typography, Col, Card, Row } from 'antd';
import CancelMortgage from '../Pages/Operaciones/MortagageAplication/CancelMortgage';
import OffersTable from '../Pages/Operaciones/Offers/OffersTable';
import OperationStage from '../Pages/onboarding/OperationStages';
import WelcomeSelection from '../Pages/onboarding/Pages/welcomeSelection';
import AutomaticDocumentation from '../Pages/Operaciones/MortagageAplication/DocumetationNew/AutomaticDocumentation/AutomaticDocumentation';
import { useAnalytics } from 'use-analytics';
import ResetPassword from '../Pages/auth/resetPassword';
import ForgotPassword from '../Pages/auth/forgotPassword';
import UnSubscribe from '../Pages/auth/unsubscribe';
import RegisterUSer from '../Pages/auth/registerUser';
import FooterComponent from './footer/footerComponent';
import Payments from '../Pages/Operaciones/Payments';

const { Text } = Typography;
const { Content, Footer } = Layout;

const Navigation = () => {
	const dispatch = useDispatch();
	const analytics = useAnalytics();
	const navigate = useNavigate();
	const location = useLocation();
	const [loading, setLoading] = useState(true);
	const [loadingI18n, setLoadingI18n] = useState(true);
	const userToken = useSelector((state) => state.auth.token);
	const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
	const changeStages = useSelector((state) => state.auth.refreshStages);
	const rol = useSelector((state) => state.auth.roles);
	const query = queryString.parse(location.search);
	const [alertClosed, setAlertClosed] = useState(false);
	const [npsAll, setNpsAll] = useState([]);
	const [, setRandomNumber] = useState();
	const { t } = useTranslation();

	useEffect(() => {
		const interval = setInterval(() => {
			if (t('login.text') !== 'login.text') {
				setLoadingI18n(false);
				clearInterval(interval); // Detiene el intervalo cuando ya está traducido
			}
		}, 500); // Revisa cada 500ms

		return () => clearInterval(interval); // Limpia el intervalo al desmontar
	}, []);

	useEffect(() => {
		// send page view on route change
		analytics.page();
	}, [analytics, location]);

	useEffect(async () => {
		await getNotificationNPS();
		setRandomNumber(Math.floor(Math.random() * 2));
	}, []);

	useEffect(() => {
		if (userToken && userToken.length > 1) {
			if (rol !== 'realestate') {
				dispatch(dataSummary(userToken));
				dispatch(dataProfile(userToken));
				setTimeout(() => {
					setLoading(false);
				}, 2000);
			} else if (rol === 'realestate') {
				dispatch(getOperations());
				dispatch(dataProfile(userToken));
				setTimeout(() => {
					setLoading(false);
				}, 2000);
			} else if (rol === 'client') {
				dispatch(dataSummary(userToken));
				dispatch(dataProfile(userToken));
				setTimeout(() => {
					setLoading(false);
				}, 2000);
			}
		}
	}, [userToken, changeStages]);

	const getNotificationNPS = async () => {
		const response = await axios.get(`${env.api.url}/v1/nps/list`, {
			headers: { Authorization: `Bearer ${userToken}` }
		});
		setNpsAll(response.data.data);

		return response.data.data;
	};

	const isSecureUrl = () => {
		let notsecured = [
			'/login',
			'/auth/forgot-password',
			'/auth/reset-password',
			'/auth/unsubscribe',
			'/auth/register'
		];

		return notsecured.findIndex((value) => new RegExp(`^${value}`).test(location.pathname)) === -1;
	};

	if (isSecureUrl() && !isAuthenticated) {
		if (query.token) {
			let customRole;

			const decodedToken = jwt_decode(query.token);

			if (decodedToken.managementCode !== 'ev') {
				axios
					.post(
						`https://prometeo.gibobs.com/webhook/9d4bbb62-fda3-463b-8046-7baa00e618d5`,
						{ managementCodePlatform: 'ev', jwt: query.token },
						{ headers: { Authorization: `Bearer ${userToken}` } }
					)
					.then(() => {
						navigate('/login');
					});
			} else {
				dispatch(
					getProfile({
						token: query.token,
						navigate,
						redirect: query.redirect,
						customRole,
						id: query.operationId
					})
				);
			}
		} else {
			if (env.app.login === 'ev') {
				navigate('/login');
			} else {
				navigate('/login');
			}
		}
	} else if (!isSecureUrl() && isAuthenticated) {
		navigate('/home');
	}

	let routesApp = <Routes />;

	if (!isAuthenticated) {
		if (loadingI18n) {
			return <LoaderLogo />;
		} else {
			return (
				<>
					<Layout style={{ height: '100vh' }}>
						<Content style={{ marginTop: 5 }}>
							<Routes>
								<Route path="/login" element={<Login />} />
								<Route path="/auth/forgot-password" element={<ForgotPassword />} />
								<Route path="/auth/reset-password" element={<ResetPassword />} />
								<Route path="/auth/unsubscribe" element={<UnSubscribe />} />
								<Route path="/auth/register" element={<RegisterUSer />} />
							</Routes>
						</Content>
						<Footer>
							<FooterComponent />
						</Footer>
					</Layout>
				</>
			);
		}
	} else {
		const commonRoutes = [
			<Route key="/documents" path="/documents" element={<DocumentsPage />} />,
			<Route key="/documents/:folderId" path="/documents/:folderId" element={<DocumentsPage />} />,
			<Route key="/help" path="/help" element={<FrequentQuestions />} />,
			<Route key="/contact" path="/contact" element={<ContactoPage />} />,
			<Route key="/notifications" path="/notifications" element={<NotificationsPage />} />,
			<Route key="/home" path="/home" element={<Home />} />
		];

		if (rol !== 'realestate') {
			routesApp = (
				<Routes>
					<Route path="/payments/operations/:operationId" element={<Payments />} />
					<Route path="/operations/clients-operations" element={<OperationsCustomer />} />
					<Route path="/cancel/operations/:operationId" element={<CancelMortgage />} />
					<Route path="/operations/:operationId/:stage" element={<OperationStage />} />
					<Route path="/welcomeSelection" element={<WelcomeSelection />} />
					<Route
						path="/compare/:operationId/:stage"
						element={<OffersTable offers={location?.state?.stage} />}
					/>
					<Route path="/products-under-contract" element={<OperationsCustomer />} />
					<Route
						path="/:operationId/:owner/automatic-documentation"
						element={<AutomaticDocumentation />}
					/>
					{commonRoutes}
					{/* FIXME: FIXIT */}
					{!location.pathname.startsWith('/opera') && !location.pathname.startsWith('/friend') && (
						<Route key="/" path="/" element={<Home />} />
					)}
				</Routes>
			);
		}
	}

	if (loading) {
		return <LoaderLogo />;
	}

	const searchItem = (location) => {
		if (
			location === '/my-financial-profile/score-gibobs' ||
			location === '/my-financial-profile/balance' ||
			location === '/my-financial-profile/credits' ||
			location === '/my-financial-profile/credits/list' ||
			location.includes('my-financial-profile/credits/form')
		) {
			return 'menuComponent.profileNav';
		} else if (
			location === '/products' ||
			location === 'operations-closed' ||
			location === '/products-under-contract' ||
			location.includes('/operations')
		) {
			return 'menuComponent.productsNav';
		} else if (
			(location.includes('/documents') && !location.includes('/sales-tools')) ||
			location.includes('/calculators')
		) {
			return 'menuComponent.resource';
		} else if (location.includes('/sales-tools/')) {
			return 'menuComponent.newRequest';
		} else if (location.includes('/products-business') || location.includes('promoter-loan')) {
			return 'menuComponent.productsBusiness';
		} else {
			return location;
		}
	};

	let npsComponent;

	let linksApps;

	return (
		<>
			<TagManager />
			{isMobileOnly && !isTablet && (
				<MobileView style={{ width: '100%' }}>
					<HeaderComponentMovile
						routesApp={routesApp}
						npsComponent={rol !== 'realestate' && npsComponent}
						selectedMenuItem={searchItem(location.pathname)}
						alertClosed={alertClosed}
					/>
				</MobileView>
			)}
			{isTablet && !isMobileOnly && (
				<TabletView>
					<HeaderComponent />
					<Layout>
						<Content
							style={{
								marginTop: '1px',
								overflowY: 'scroll',
								position: 'relative',
								height: '100vh'
								// left: -10,
							}}>
							<div>
								<div>
									{/*profileDateGet && profileDateGet.hasPassword === false && (
                                    <AlertPassword></AlertPassword>
                                )*/}
									{rol !== 'realestate' ? npsComponent : undefined}
								</div>
								{routesApp}

								{rol !== 'realestate' &&
								(location.pathname.startsWith('/dashboard-client') ||
									location.pathname.startsWith('/products') ||
									location.pathname.startsWith('/products-under-contract') ||
									location.pathname.startsWith('/friend') ||
									location.pathname.startsWith('/friendInfo') ||
									location.pathname.startsWith('/calculators'))
									? // randomNumber === 0
									  // 	? bannerAmigobs
									  // 	:
									  linksApps
									: undefined}
							</div>
						</Content>
					</Layout>
				</TabletView>
			)}
			{!isMobileOnly && !isTablet && (
				<BrowserView>
					<HeaderComponent />
					<Layout>
						<Content
							style={{
								minWidth: '70vh',
								marginTop: location.pathname.includes('automatic-documentation') ? 0 : 10,
								overflowY: 'scroll',
								position: 'relative',
								height: '100vh'
							}}>
							<div>
								{/*profileDateGet && profileDateGet.hasPassword === false && (
                                <AlertPassword></AlertPassword>
                            )*/}
								{rol !== 'realestate' ? npsComponent : undefined}
								<div
									style={{
										minHeight:
											rol !== 'realestate' &&
											(location.pathname.startsWith('/products') ||
												location.pathname.startsWith('/products-under-contract') ||
												location.pathname.startsWith('/friend') ||
												location.pathname.startsWith('/friendInfo') ||
												location.pathname.startsWith('/calculators'))
												? '91vh'
												: location.pathname.startsWith('/dashboard-client') && '88vh'
									}}>
									{routesApp}
								</div>

								{rol !== 'realestate' &&
								(location.pathname.startsWith('/dashboard-client') ||
									location.pathname.startsWith('/products') ||
									location.pathname.startsWith('/products-under-contract') ||
									location.pathname.startsWith('/friend') ||
									location.pathname.startsWith('/friendInfo') ||
									location.pathname.startsWith('/calculators'))
									? // randomNumber === 0
									  // 	? bannerAmigobs
									  // 	:
									  linksApps
									: undefined}
							</div>
						</Content>
					</Layout>
				</BrowserView>
			)}
		</>
	);
};

export default Navigation;
